import React, { Component } from 'react';
import { ValidationModal } from '../components/index';
import moment from "moment";
import { PdfViewer } from "./index";
import { SaleDetailsModal } from '../components';
import { FORMAT_NUMBER, CURRENCY, SYMBOL } from '../libs/utils/Const';

class SalesModal extends Component {

    shouldComponentUpdate = (nextProps) => {
        if (this.props !== nextProps) {
            return true;
        }
    }

    RefreshModel = (ordersSearchModel) => {
        const { SalesTools } = this.props;
        SalesTools.RefreshSearchOrdersModel(ordersSearchModel);
    }

    OnchangeCardCode = (value) => {
        const { SalesTools } = this.props;
        SalesTools.ordersSearchModel.CardCode = value;
        this.RefreshModel(SalesTools.ordersSearchModel);
    }
    OnchangeDocNum = (value) => {
        const { SalesTools } = this.props;
        SalesTools.ordersSearchModel.DocNum = value;
        this.RefreshModel(SalesTools.ordersSearchModel);
    }

    render() {
        const { ShowSalesModal, SalesTools, user } = this.props;
        
        return (
            <div>
                <div className="modal fade  modal-fullscreen" id="salesModal" data-backdrop="false" data-keyboard="false" tabIndex="-1" aria-labelledby="salesModalLabel" aria-hidden="true" >
                    <div className="modal-dialog" >
                        <div className="modal-content">
                            <div className="modal-header" style={{ background: "#343a40" }}>
                                <img src={require('../images/logocounter.png')} className="image" alt="COUNTER ONE" />
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{ color: "white" }} onClick={() => { ShowSalesModal(); SalesTools.CloseModalActions() }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <h4 className="modal-title ml-4" id="refundModalLabel">Acciones</h4>
                                </div>
                                <div className="container-fluid mt-3">
                                    <div className="row">
                                        <div className="col-md-12">
                                            {/* <div className="row ml-3">
                                                <div className="col-4">
                                                    <div className="input-group mb-3">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text" id="basic-addon1"><strong>Buscar pedido</strong></span>
                                                        </div>
                                                        <input type="text" className="form-control"
                                                            placeholder="N° de documento"
                                                            onKeyPress={(ev) => { if (ev.key === 'Enter') { SalesTools.SearchOrders() } }}
                                                            onChange={(event) => this.OnchangeDocNum(event.target.value)}
                                                            value={SalesTools.ordersSearchModel.DocNum ?? ''} />
                                                    </div>
                                                </div>
                                                <div className='col-3'>
                                                </div>
                                            </div> */}
                                            {/* <div className="row m-3">
                                                <div className='col-3'>
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text"><strong>Cliente</strong></span>
                                                        </div>
                                                        <input
                                                            type="text" className="form-control"
                                                            onKeyPress={(ev) => { if (ev.key === 'Enter') { SalesTools.SearchOrders() } }}
                                                            onChange={(event) => this.OnchangeCardCode(event.target.value)}
                                                            value={SalesTools.ordersSearchModel.CardCode ?? ''} />
                                                    </div>
                                                </div>
                                                <div className='col-3 text-left'>
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text"><strong>Desde: </strong></span>
                                                        </div>
                                                        <input type="date" className="form-control"
                                                            onKeyPress={(ev) => { if (ev.key === 'Enter') { SalesTools.SearchOrders() } }}
                                                            max='9999-12-31'
                                                            value={SalesTools.initialDate} onChange={(event) => SalesTools.ChangeInitialDate(event)} />
                                                    </div>
                                                </div>
                                                <div className='col-3 text-left'>
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text"><strong>Hasta: </strong></span>
                                                        </div>
                                                        <input type="date" className="form-control"
                                                            onKeyPress={(ev) => { if (ev.key === 'Enter') { SalesTools.SearchOrders() } }}
                                                            max='9999-12-31'
                                                            value={SalesTools.finalDate} onChange={(event) => SalesTools.ChangeFinalDate(event)} />
                                                    </div>
                                                </div>
                                                <div className="col-md-3 text-right">

                                                </div>
                                            </div> */}

                                            <div className='row'>
                                                <div className="col-md-9 ">
                                                    <div className="row mt-3">
                                                        <div className="col-7">
                                                            <div className="input-group mb-3">
                                                                <div className="input-group-prepend">
                                                                    <span className="input-group-text" id="basic-addon1"><strong>Folio: </strong></span>
                                                                </div>
                                                                <input type="text" className="form-control"
                                                                    placeholder="Folio de la entrega o factura"
                                                                    onKeyPress={(ev) => { if (ev.key === 'Enter') { SalesTools.SearchOrders() } }}
                                                                    onChange={(event) => this.OnchangeDocNum(event.target.value)}
                                                                    value={SalesTools.ordersSearchModel.DocNum ?? ''} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-md-3 text-right' >
                                                    <button type="button" className="btn btn-outline-primary mr-2 mt-4 mb-4" data-toggle="modal" onClick={() => SalesTools.SendDocsToPdfViewer()}>Facturar</button>
                                                    <button type="button" className="btn btn-outline-danger ml-2" onClick={() => SalesTools.CloseDocument()}>Cancelar Venta</button>
                                                </div>
                                            </div>
                                            <div className='card scrollTableRefound' style={{ maxHeight: "500px" }}>
                                                <table className="table table-striped table-hover">
                                                    <thead>
                                                        <tr>
                                                            <th className="text-center"></th>
                                                            <th className="text-center">Folio</th>
                                                            <th className="text-center">Fecha</th>

                                                            <th className="text-center">Estación</th>
                                                            <th className="text-center">Doc. Status</th>
                                                            <th className="text-center">Nombre de cliente</th>

                                                            <th className="text-center">Total</th>
                                                            <th className="text-center">Info</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {SalesTools.ordersDocs.length > 0 &&
                                                            SalesTools.ordersDocs.map((doc) => {
                                                                return (
                                                                    <tr key={doc.DocEntry}>
                                                                        <td className="text-right">
                                                                            <input
                                                                                disabled={doc.docStatus === 'C' ? true : false}
                                                                                type="radio"
                                                                                checked={SalesTools.ordersToAction === doc.folio ? true : false}
                                                                                value={doc.folio}
                                                                                onClick={(event) => SalesTools.GetDocFolio(event.nativeEvent.target.value)}
                                                                            >
                                                                            </input>
                                                                        </td>
                                                                        <td className="text-center">{doc.folio}</td>
                                                                        <td className="text-center">{moment(doc.DocDate).format('YYYY-MM-DD')}</td>
                                                                        <td className="text-center">SQL</td>
                                                                        <td className="text-center">{doc.docStatus === 'C' ? 'Cerrado' : 'Abierto'}</td>
                                                                        <td className="text-center">{doc.CardName}</td>
                                                                        <td className="text-center">{FORMAT_NUMBER.new(doc.docTotal)}</td>
                                                                        <td className="text-center" onClick={() => SalesTools.ShowDocInfo(doc.folio)}><i className="fa fa-info-circle" aria-hidden="true" data-dismiss="modal" /></td>
                                                                    </tr>
                                                                );
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-9">
                                                </div>
                                                <div className="col-3 text-right">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => SalesTools.CloseModalActions()}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
                <ValidationModal
                    idValidation="vmCloseIV"
                    message="SELECCIONO UNA FACTURA, SE GENERARA UNA NOTA DE CRÉDITO ¿DESEA CONTINUAR?"
                    idModalOrigin="#salesModal"
                    idModalDestiny="#salesModal"
                    eventOnclick={SalesTools.CloseDocument}
                />
                <ValidationModal
                    idValidation="vmCloseDL"
                    message="SE CERRARA LA ENTREGA Y SE GENERARA UNA DEVOLUCIÓN ¿DESEA CONTINUAR?"
                    idModalOrigin="#salesModal"
                    idModalDestiny="#salesModal"
                    eventOnclick={SalesTools.CloseDocument}
                // eventOnclick2={()=>SalesTools.CloseModalByID('vmCloseDL')}
                />

                {SalesTools.showPDFViewer &&
                    <PdfViewer
                        DocsToPrint={SalesTools.docsToPrint}
                        TypeDoc={'OINV'}
                        EnableEditButton={false}
                        Editable={SalesTools.editableMode}
                        ChangeEditableMode={SalesTools.ChangeEditableMode}
                        EditableDocModel={SalesTools.EditableDocModel}
                        RefreshDocModel={SalesTools.RefreshDocModel}
                        SaveChanges={SalesTools.SaveChangesOrderInvoice}
                        UploadDoc={SalesTools.UploadInvoice}
                        EditParam1={false}
                        ShowPDFViewer={SalesTools.ShowPDFViewer}
                        user={user}
                        reprint={false}
                    />
                }
                <SaleDetailsModal
                    DocHeader={SalesTools.detailDoc.docHeader}
                    DocLines={SalesTools.detailDoc.docLines}
                    SalesTools={SalesTools}

                />

            </div>
        );
    }
}

export default SalesModal;